import { observer } from 'mobx-react-lite'
import React, { useContext, useEffect } from 'react'
import { Droppable } from 'react-beautiful-dnd'
import { Dot, Folder, ThreeDotsVertical } from 'react-bootstrap-icons'
import { useNavigate, useParams } from 'react-router-dom'
import { CampaignContext } from '../../../../../contexts/CampaignContext'
import CreateFolderButton from './FolderParts/CreateFolderButton'
import FolderDropdownButton from './FolderParts/FolderDropdownButton'
import { useReadOnly } from '../../../../../contexts/ReadOnlyContext'

export default observer(function Folders() {
  const { campaign_folder_id, id } = useParams()
  const { campaign, campaignFolders, documentSearch } = useContext(CampaignContext)
  const readOnly = useReadOnly()
  const navigate = useNavigate()

  useEffect(() => {
    documentSearch.campaign_folder_id = campaign_folder_id
  }, [campaign_folder_id])

  const openFolder = campaignFolderId => () => {
    if(+documentSearch.campaign_folder_id === +campaignFolderId) {
      navigate(`/project_manager/campaigns/${id}/files`)
    } else {
      navigate(`/project_manager/campaigns/${id}/campaign_folders/${campaignFolderId}/files`)
    }
  }

  return (
    <div>
      <div className="flex items-center mb-2">
        <h2 className="font-bold text-base dark:text-white">Folders</h2>
        <p className="font-semibold text-base text-gray-300 dark:text-gray-500 flex items-center"><Dot /> {campaignFolders.length}</p>
      </div>
      <div className="flex flex-wrap gap-4 w-full">
        {!readOnly && <CreateFolderButton />}
        {campaignFolders.map(campaignFolder => (

          <Droppable key={campaignFolder.id} droppableId={`${campaignFolder.id}`} isDropDisabled={readOnly}>
            {(provided, snapshot) => (
              <div
                ref={provided.innerRef}
                {...provided.droppableProps}
                className={`border-1 border-gray-300 dark:border-rb-dark-mode-lighter flex items-center ${snapshot.isDraggingOver ? 'bg-gray-400 dark:bg-rb-dark-mode-lighter' : +documentSearch.campaign_folder_id === +campaignFolder.id ? 'bg-rb-green dark:bg-rb-green/20' : 'bg-white dark:bg-rb-dark-mode'} rounded w-80 h-18 justify-between`}
              >
                <div className="flex items-center">
                  <div className="ml-4 p-2 bg-gray-200 dark:bg-rb-dark-mode-lighter rounded-md dark:text-gray-400" >
                    <Folder />
                  </div>
                  <button className="font-bold ml-4 dark:text-white" onClick={openFolder(campaignFolder.id)}>{campaignFolder.name}</button>
                </div>
                <div className="flex items-center">
                  <div className="ml-4 bg-gray-200 rounded-full w-8 h-8 text-center flex items-center justify-center">
                    {campaignFolder.documents_count}
                  </div>
                  {readOnly ? <div className="mx-4" /> : <FolderDropdownButton campaignFolder={campaignFolder} />}
                </div>
              </div>
            )}
          </Droppable>
        ))}
      </div>
    </div>
  )
})